import { useSelector } from 'react-redux'
import OTPInputField from '../../../../components/OTPInputField'
import Spinner from '../../../../components/Spinner'
import Text from '../../../../components/Text'
import { useEffect, useState } from 'react'

// icons
import CallIcon from '../../../../assets/icons/call-icon.svg'
import EditIcon from '../../../../assets/icons/edit-icon.svg'
import UserIcon from '../../../../assets/icons/user-icon.svg'

const OTPScreen = ({
  handleEditClick,
  handleResendOtp,
  formObject,
  handleVerifyOtp,
  isLoading,
  timer,
}) => {
  const [otp, setOtp] = useState('')
  const [otpError, setOtpError] = useState(false)
  const { sendOtp, verifyOtp } = useSelector((state) => state.auth)

  // Handle On Verify OTP Error
  useEffect(() => {
    if (verifyOtp?.data?.code === 0) {
      setOtpError(true)
    }
  }, [verifyOtp])

  // Handle On Edit Click
  const handleOnEditClick = () => {
    handleEditClick('phone')
    setOtp('')
    setOtpError(false)
  }

  // Handle On OTP Change
  const handleOnOtpChange = (otp) => {
    setOtp(otp)
    setOtpError(false)

    if (otp.length === 6) {
      handleVerifyOtp(otp)
    }
  }
  // Handle On Resend OTP
  const handleOnResendOtp = () => {
    setOtpError(false)
    setOtp('')
    handleResendOtp()
  }

  return (
    <div>
      <Text
        variant="display"
        size="small"
        className="text-[#101828] mb-3"
        tag="h2"
      >
        Enter OTP
      </Text>
      <Text variant="body" size="large" className="text-[#344054]" tag="p">
        An OTP is sent to the following number
      </Text>
      <div className="flex items-center gap-1 text-base font-medium text-[#101828] pt-4">
        <div className="flex items-center gap-3">
          <Text
            variant="body"
            size="medium"
            tag="div"
            className="flex items-center gap-1.5 whitespace-nowrap"
          >
            <img src={CallIcon} alt="call-icon" className="w-4 h-4" />
            +91 {formObject?.contactNo}
          </Text>
          <span>|</span>
          <Text
            variant="body"
            size="medium"
            tag="div"
            className="capitalize flex items-center gap-1.5 whitespace-nowrap"
          >
            <img src={UserIcon} alt="call-icon" className="w-4 h-4" />
            {formObject?.name}
          </Text>
        </div>
        <button
          className="ml-2 text-[#299D6B] flex items-center gap-1"
          onClick={handleOnEditClick}
        >
          Edit <img src={EditIcon} alt="edit-icon" />
        </button>
      </div>

      <OTPInputField
        label="Secure Code"
        value={otp}
        onChange={handleOnOtpChange}
        className="mt-6"
        error={otpError}
        helperText={otpError ? 'Invalid OTP' : ''}
        disabled={verifyOtp?.loading || isLoading}
      />

      <div className="flex items-center gap-2 mt-6">
        <Text variant="body" size="medium" tag="p" className="text-[#667085]">
          Didn't receive the OTP?
        </Text>
        {sendOtp?.loading ? (
          <div className="flex items-center gap-2">
            <Text
              variant="body"
              size="medium"
              tag="p"
              className="text-[#667085]"
            >
              Resending OTP
            </Text>
            <Spinner />
          </div>
        ) : timer > 0 ? (
          <Text variant="body" size="medium" tag="p" className="text-[#667085]">
            Resend OTP in 00:{timer < 10 ? `0${timer}` : timer}
          </Text>
        ) : (
          <button onClick={handleOnResendOtp}>
            <Text
              variant="body"
              size="medium"
              tag="p"
              className="text-[#299D6B] font-medium"
            >
              Resend OTP
            </Text>
          </button>
        )}
      </div>

      {verifyOtp?.loading || isLoading ? (
        <div className="flex items-center gap-2 mt-6">
          <Text variant="body" size="medium" tag="p" className="text-[#667085]">
            Verifying OTP
          </Text>
          <Spinner />
        </div>
      ) : null}
    </div>
  )
}

export default OTPScreen
